import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export const ShouldRequoteOnTaxStatusChange = (x: SmartSendItemApiModel, y: SmartSendItemApiModel) =>
  x.Sender.VatStatus !== y.Sender.VatStatus || x.Recipient.VatStatus !== y.Recipient.VatStatus;
export default ShouldRequoteOnTaxStatusChange;
